// extracted by mini-css-extract-plugin
module.exports = {"SplashScreen":"Splash_SplashScreen__1bYFk","Branding":"Splash_Branding__3B2Yy","Slogan":"Splash_Slogan__2QEOl","Logo":"Splash_Logo__2ju3E"};